<template>
  <div style="" class="father">
    <div class="right">
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        style="width: 100%;height: 500px;background-color: #fff;"
      >
        <div class="father">
          <el-form
            label-width="300px"
            style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
            ref="dataFormRef"
            :model="merchant"
            :rules="rules"
            label-position="top"
          >
            <div class="title">
              基本信息
            </div>
            <!-- <el-form-item
              label="营业执照（上传营业执照进行识别）"
              prop=""
              style="height:193px;"
              v-if="!modify"
            >
              <uploadImg
                class="uploadImg"
                :imgTitle="'yyzz'"
                @getReturn="getReturn"
                @removeImg="removeImg"
              >
                <template slot="centerName">
                  营业执照
                </template>
              </uploadImg>
            </el-form-item> -->
            <!-- <el-form-item label="店铺状态：" v-model="mch_type" v-if="modify">
              <wty-radio
                @wtyRadioChange="wtyRadioChange"
                :radioList="radioList"
                :checked="merchant.state"
              ></wty-radio>
            </el-form-item> -->
            <div v-for="(item, index) in formList" :key="index">
              <div class="title" style="" v-if="index == 8">
                选填信息
              </div>
              <el-form-item :label="item.label" :prop="item.value">
                <el-input
                  clearable
                  :disabled="modify"
                  :show-password="item.value == 'pass_word'"
                  :blur="
                    item.value == 'sub_name'
                      ? subNameBlur(true)
                      : subNameBlur(false)
                  "
                  v-model="merchant[item.value]"
                  :placeholder="`请输入${item.label}`"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="wty-footer">
        <!-- <el-button type="danger" @click="resetForm"> 新建 </el-button> -->
        <el-button type="primary" @click="saveMerchantChange"> 保存 </el-button>
        <!-- <el-button type="primary" @click="MerchantGenerate">
          保存
        </el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
// import uploadImg from "@/components/uploadImg.vue";
let pinyin = require("js-pinyin");
import { getMerchantInfo, modifyMerchantInfo } from "@/api/merchant.js";
import { getLongitudeLatitude, getJingWei } from "@/js/public.js";
export default {
  name: "information",
  data() {
    return {
      modify: false,
      formList: [],
      mch_id: localStorage.getItem("mch_id"),
      merchant: {
        merchant_name: "", //店铺名称
        sub_name: "", //店铺简称
        mobile_no: "", //联系人手机号码
        pass_word: "", //登录密码
        license_code: "", //营业执照
        address: "", //店铺地址
        contacts_man: "", //联系人姓名
        e_mail: "", //电子邮箱
        phone: "", //固定电话
        fax: "", //传真号码
        pym: "", //拼音码
        service_phone: "", //服务热线
        mch_type: "01", //店铺类型号
        longitude: "", //店铺位置 经度
        latitude: "" //店铺位置 纬度
      },
      rules: this.getRules()
    };
  },
  // components: { uploadImg },
  async mounted() {
    //TODO: 经纬度信息获取超时
    // getLongitudeLatitude();
    const res = await getMerchantInfo();
    if (this.testR(res)) {
      this.merchant = { ...res.data.resp_data };
    }
  },
  methods: {
    saveMerchantChange() {
      modifyMerchantInfo(this.merchant).then(res => {
        if (this.testR(res)) {
          this.successMessage(res.data.resp_data.state);
        }
      });
    },
    subNameBlur(key) {
      if (key) {
        this.merchant.pym = pinyin.getCamelChars(this.merchant.sub_name);
      }
    },
    getRules() {
      let list = [
        { label: "营业执照号：", value: "license_code", type: "false" },
        { label: "店铺名称：", value: "merchant_name", type: "false" },
        { label: "店铺简称：", value: "sub_name", type: "false" },
        { label: "拼音码：", value: "pym", type: "false" },
        { label: "登录密码：", value: "pass_word", type: "false" },
        { label: "联系人手机号码：", value: "mobile_no", type: "false" },
        { label: "服务热线：", value: "service_phone", type: "false" },
        { label: "联系人姓名：", value: "contacts_man", type: "false" },

        { label: "店铺地址：", value: "address", type: "true" },
        { label: "电子邮箱：", value: "e_mail", type: "true" },
        { label: "固定电话：", value: "phone", type: "true" },
        { label: "传真号码：", value: "fax", type: "true" },
        { label: "店铺类型号：", value: "mch_type", type: "true" },
        { label: "经度：", value: "longitude", type: "true" },
        { label: "纬度：", value: "latitude", type: "true" }
      ];
      var rules = {};
      var wtycolumnList = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].type == "false") {
          rules[list[i].value] = [
            {
              required: true,
              message: `请输入${list[i].label}`,
              trigger: "blur"
            }
          ];
        }
        // if (i == 7) break;
      }
      wtycolumnList.push({
        prop: "merchant_id",
        align: "center",
        label: "店铺ID",
        width: "200",
        fixed: "left"
      });
      wtycolumnList.push({
        prop: "merchant_name",
        align: "center",
        label: "店铺名称",
        width: "200",
        fixed: false
      });
      // console.log(wtycolumnList)
      //没有营业执照的rule
      rules.license_code = [
        {
          required: true,
          message: `请上传营业执照照片`,
          trigger: "blur"
        }
      ];
      this.$nextTick(() => {
        this.formList = list;
        this.wtycolumnList = wtycolumnList;
      });
      return rules;
      // console.log(JSON.stringify(rules));
    },
    getReturn(res) {
      if (JSON.stringify(res) == "{}") {
        this.warnMessage("未识别出有效内容，请重试");
      } else {
        this.successMessage("识别成功");
        this.merchant.merchant_name = res.CommpanyName;
        this.merchant.address = res.Address;
        this.merchant.contacts_man = res.LegalPerson;
        this.merchant.license_code = res.LicenseCode;
      }

      // res.media_no = this.merchant.license_code;
    },
    removeImg(imgTitle) {
      switch (imgTitle) {
        case "fm":
          // this.img_legal_id_back = "";
          break;
        case "zm":
          // this.img_legal_id_front = "";
          break;
        case "yyzz":
          // this.img_license = "";
          break;
      }
    }
  }
};
</script>
<style scoped lang="less">
.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}
.el-breadcrumb {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 16px;
  z-index: 99;
}
.father {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding: 10px;
}
.fa-morf {
  margin-top: 20px;
}

.right {
  width: 50%;
  min-width: 600px;
  float: left;
}
.el-input {
  width: 400px;
}
.wty-footer {
  height: 50px;
  .el-button {
    width: 200px;
  }
}
</style>
